import type { HTMLAttributes } from 'react';
import { ENGINE_PROP_NAMES } from './CustomMindmap.types';
import type { CustomMindmapProps } from './CustomMindmap.types';

const OWN_PROP_NAMES = new Set(['className', 'children']);

/** Only real DOM props reach the root div: engine props (built or pending) and the ones the root handles are dropped. */
export const toDivProps = (props: CustomMindmapProps): HTMLAttributes<HTMLDivElement> =>
  Object.fromEntries(
    Object.entries(props).filter(([name]) => !ENGINE_PROP_NAMES.has(name) && !OWN_PROP_NAMES.has(name)),
  ) as HTMLAttributes<HTMLDivElement>;
